import { Injectable } from '@angular/core';
import * as DialogActions from '../../dialog/features/dialog.actions';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class EventPageHeaderTypeService {

  constructor(
    private store: Store,
  ) { }

  onShowDescription(text: string): void {
    const action = DialogActions.openDialog({
      payload: {
        name: 'customText',
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee',
        },
        initialState: {
          textContent: text
        }
      }
    });

    this.store.dispatch(action);
  }

  getUserTimezone(): string {
    const formatter = new Intl.DateTimeFormat([], { timeZoneName: 'short' });
    const parts = formatter.formatToParts(new Date());
    const timeZone = parts.find(part => part.type === 'timeZoneName')?.value || '';
    return timeZone;
  }
}
